import { render, staticRenderFns } from "./homeOld.vue?vue&type=template&id=e85daf74&scoped=true&"
import script from "./homeOld.vue?vue&type=script&lang=js&"
export * from "./homeOld.vue?vue&type=script&lang=js&"
import style0 from "./homeOld.vue?vue&type=style&index=0&id=e85daf74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85daf74",
  null
  
)

export default component.exports